import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'
import parser from 'html-react-parser'
import ApproachMapSlider from '@components/OurApproach/ApproachMapSlider';

export default function ContentCards4({ data }) {
    const { contentCards4ButtonText, contentCards4ShowMap, contentCards4Title, contentCards4Text, contentCards4ButtonLink, contentCards4Cards, contentCards4ButtonExternalLink } = data
    return (
        <div className='our-imapct-video-wrap global-comet-vid-wrap light-grey-bg'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <figure className='abt-origins-icon mb-3'>
                            <StaticImage
                                src='../../../images/origins-icon.png'
                                alt='image'
                            />
                        </figure>
                        <div className='imapact-vid-sec our-impact-vid-sec'>
                            <h2 className='heading-level-2 blue-color text-center'>
                                {contentCards4Title && parser(contentCards4Title)}
                            </h2>
                            <p>{contentCards4Text && parser(contentCards4Text)}</p>
                        </div>
                    </div>
                </div>
            </div>

            {contentCards4ShowMap && <ApproachMapSlider />}

            <div className='container'>
                <div className='row d-green-box-row our-impact-row-2'>
                    {contentCards4Cards.map((block, i) => (
                        <div className='col-md-4 d-green-col-md' key={i}>
                            <div className='green-col-1 mid-blue-bg-col'>
                                <div className='heading-level-2 mb-2 blue-color'>
                                    {block.contentCards4CardTitle && parser(block.contentCards4CardTitle)}
                                </div>
                                <p>{block.contentCards4CardText && parser(block.contentCards4CardText)}</p>
                            </div>
                        </div>
                    ))}

                    <div className='col-md-12 mt-5 text-center'>
                        {contentCards4ButtonExternalLink ? (
                            <a href={contentCards4ButtonExternalLink} className="btn blue-btn">
                                {contentCards4ButtonText}
                            </a>
                        ) : contentCards4ButtonLink ? (
                            <Link to={contentCards4ButtonLink.uri} className='btn blue-btn'>
                                {contentCards4ButtonText}
                            </Link>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}
